export function ordenarPorIdDeposito(opcoes) {
    const idDeposito = opcao => {
        const valor = opcao && opcao.depoId;
        if (valor === null || valor === undefined || String(valor).trim() === '') return Infinity;
        const numero = Number(valor);
        return Number.isFinite(numero) ? numero : Infinity;
    };
    return (opcoes || []).slice().sort((a, b) => {
        const primeiro = idDeposito(a);
        const segundo = idDeposito(b);
        return primeiro === segundo ? 0 : primeiro - segundo;
    });
}



// WEBPACK FOOTER //
// ./src/components/helpers/OrdenacaoDepositosHelper.js